import { Statement } from './models/statement.model';

export enum StatementDocumentTypesEnum {
  invoice = 'invoice',
  credit_memo = 'credit_memo',
}

export const STATEMENT_ACCEPT_VERSION = '4.3.0';
export const STATEMENT_METRICS_ACCEPT_VERSION = '3.1.0';

export interface IStatementInfoParams {
  client_billing_name: string;
  client_id: string;
  end_date: string;
  start_date: string;
  unpaid_only: boolean;
  currency_code: string;
}

export interface IStatementMetricParams {
  client_id: string;
  client_billing_name: string;
  currency_code?: string;
}

export interface IStatementData {
  statement: Statement;
  delivery_options: {
    template_id: string;
    template_data: {
      language: string;
      statement_url: string;
      payment_methods: { [creditCard: string]: boolean };
      subject_link_spamcheck: string;
      body_spamcheck: string;
      super_subject: string;
      show_footer: string;
      card_payments_globally_enabled: boolean;
      paypal_ec_globally_enabled: boolean;
    };
    recipients: string[];
    cc_emails: string[];
    bcc_emails: string[];
    subject: string;
    from_name: string;
    reply_to_email: string;
    file_name: string;
  };
}
